import * as React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

// Typescript definition
import { jsx as _jsx } from "react/jsx-runtime";
// TranslateText component with props and its types
const _TranslateText = props => {
  const {
    id,
    values
  } = props;
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: typeof id === "number" ? id : id != undefined && id != null && id != "" ? /*#__PURE__*/_jsx(FormattedMessage, {
      id: id,
      values: values || {}
    }) : ''
  });
};

// Prop type definition for compile time

// Default props
_TranslateText.defaultProps = {
  id: '',
  values: {}
};
export const TranslateText = injectIntl( /*#__PURE__*/React.memo(_TranslateText));